import { LazySwiperWhenVisible } from '@/utils/Controllers/LazySwiperController';
import SmarteditController from '@/utils/Controllers/SmarteditController';
import _isEmpty from 'lodash/isEmpty';

const SELECTOR = '.js-del-contentSlider';

const loadController = async (sliderWrapper, SwiperLib) => {
  const controller = await import(
    /* webpackChunkName: "DELContentSliderController-lib" */ '@/delonghi/Controllers/DELContentSlider/DELContentSliderController'
  );
  controller.default(sliderWrapper, SwiperLib);
};

const init = () => {
  const entries = SmarteditController.getEditorialEntries(SELECTOR);
  if (!_isEmpty(entries)) {
    LazySwiperWhenVisible(entries, async (sliderWrapper, SwiperLib) => {
      loadController(sliderWrapper, SwiperLib);
    });
  }
};

export default async () => {
  SmarteditController.addOnReprocessPageListener(init);
  init();
};
